import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect,
  MultiSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import Template1 from './../../../../shared/components/Template1'
import MasterService from './../../../../masterdata/services/masterdata.service';
export default {
  name: 'createContract',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    MultiSelect,
    Template1
  },
  props: ['selectedEditRowData'],
  data: function() {
    return {
      contractname: '',
      showTemplateFlag: true,
      isLoading: false,
      contractnameerr: '',
      selectedEditRow: this.selectedEditRowData && JSON.parse(JSON.stringify(this.selectedEditRowData)),

    }
  },
  computed: {

  },
  mounted() {
    this.check()
  },
  methods: {
    check() {
      if (this.selectedEditRowData.id) {
        this.contractname = this.selectedEditRowData.contracttemplatename
      }

    },
    showCreateContract() {
      this.$emit("goBackToParent")
    },

    checkForContractValidation(){
      if (!this.contractname || !this.contractname.trim()) {
        this.contractnameerr = "Please Select Contract Name"
        const el = document.getElementById("contract-Heading");
        el.scrollIntoView();
      } else {
        this.contractnameerr = '';
      }
    },
    async saveContractService(payload, buttonclick) {
      try {
        if (this.contractname.trim()) {
          this.contractnameerr = ''
          payload.contracttemplatename = this.contractname.trim();
          this.isLoading = true
          let result = await MasterService.saveServicesForContract(payload);
          this.isLoading = false
          if (result.data.code == 200) {
            this.$alert(result.data.message, this.contractname, "success");
            this.selectedEditRow.id = result.data.data.id
            if(buttonclick == 'Save'){
              this.$emit("goBackToParent")
            } else {
              this.$refs.ContractChilds.getContractID(result.data.data.id, buttonclick);
            }
          } else {
            this.$alert(result.data.message, this.contractname, "error");
          }
        } else {
          this.contractnameerr = "Please Select Contract Name"
        }
      } catch (err) {
        this.isLoading = false;
        this.$alert(err, "Contract", "error");
        console.log(err);
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/contracttemplate/createContractTemplate/createContractTemplate.component.js